import './edit_product_modal.css'
import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { update_articles } from '../../../../../services/purchase_service'


function Edit_product_modal({ open_edit_product_modal,refresh_request_articles, articleIndex, setOpen_edit_product_modal, article, setArticle, articles, request_code }) {
  
  const [errorText, setErrorText] = useState("");
  const [description, setDescription] = useState('');
  const [waiting, setWaiting] = useState(false);


  useEffect(() => {
    if (article) {
      setDescription(article);
    }
  }, [article]);


  async function edit_description() {
    setWaiting(true);
    const updatedArticles = [...articles];
    updatedArticles[articleIndex] = description;
    let formData = new FormData();
    formData.append('products', JSON.stringify({ articles: updatedArticles }));
    formData.append('request_code', request_code);
    await update_articles(formData).then((response) => {
      refresh_request_articles(response.data.updated_products);
    }).catch((error)=>{
     //  console.log(error.response);
    });
    setWaiting(false);
    setOpen_edit_product_modal(false);
  };

  return (
    <Dialog
      className="set_refuse_raison_container"
      fullWidth
      maxWidth="md"
      open={open_edit_product_modal}
      onClose={() => setOpen_edit_product_modal(false)}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Modifiez la description de l'article</DialogTitle>
      <DialogContent>
        {errorText && (
          <p className="error">{errorText}</p>
        )}

        <TextField
          id="outlined-multiline-flexible"
          label="Description"
          variant="outlined"
          multiline
          minRows={4}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          style={{ width: "100%", marginTop: "5px" }}
        />
      </DialogContent>
      <DialogActions>
        <div className="dialogBottom">
          <div>
            {errorText && <p className="error">{errorText}</p>}
          </div>
          <div>
            <Button
              variant="contained"
              className="submit_but cancel_but"
              startIcon={<CancelIcon className="my_icon" />}
              onClick={() => setOpen_edit_product_modal(false)}
            >
              Annuler
            </Button>
            <Button
              variant="contained"
              className="submit_but valide_but"
              startIcon={<EditIcon className="my_icon" />}
              onClick={edit_description}
            >
              Modifier
            </Button>
          </div>
        </div>
      </DialogActions>
      <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
    </Dialog>
  );
}

export default Edit_product_modal;



